(() => {
  if (window.__BHD_LAUNCH_STATE_V2__) return;
  window.__BHD_LAUNCH_STATE_V2__ = true;

  const LIVE_WINDOW_MS = 48 * 60 * 60 * 1000;
  const TICK_MS = 1000;
  const REDUCED_MOTION = window.matchMedia?.('(prefers-reduced-motion: reduce)');

  const parseDate = (value) => {
    if (!value) return 0;
    let parsed = Date.parse(value);
    if (Number.isNaN(parsed)) parsed = Date.parse(String(value).replace(/-/g, '/'));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const isSpanish = () => (document.documentElement.lang || '').toLowerCase().startsWith('es');
  const addToCartLabel = () => window.theme?.variantStrings?.addToCart || (isSpanish() ? 'AGREGAR AL CARRITO' : 'ADD TO CART');
  const availableNowLabel = () => isSpanish() ? 'YA DISPONIBLE' : 'AVAILABLE NOW';

  const setElementLabel = (element, label) => {
    if (!element || !label) return;
    const textNode = Array.from(element.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (textNode) {
      textNode.textContent = `\n${label}\n`;
      return;
    }
    const textTarget = element.querySelector('[data-label], .button__text, .product-form__submit-text');
    if (textTarget) {
      textTarget.textContent = label;
      return;
    }
    element.insertBefore(document.createTextNode(`${label} `), element.firstChild);
  };

  const normalizeAddToCart = (scope = document) => {
    scope.querySelectorAll?.('button[name="add"][data-pre-order="true"], add-to-cart[data-variant-id]').forEach((button) => {
      if (button.matches('button[name="add"]')) {
        button.removeAttribute('data-pre-order');
        if (!button.disabled && /pre[ -]?order|preorder|preventa|reservar/i.test(button.textContent || '')) {
          setElementLabel(button, addToCartLabel());
        }
        return;
      }

      if (/pre[ -]?order|preorder|preventa|reservar/i.test(button.textContent || '')) {
        setElementLabel(button, addToCartLabel());
      }
    });
  };

  const injectStyles = () => {
    if (document.getElementById('BhdLaunchStateStyles')) return;
    const style = document.createElement('style');
    style.id = 'BhdLaunchStateStyles';
    style.textContent = `
      .bhd-premium-launch-live {
        position:absolute;
        inset:0;
        z-index:45;
        display:grid;
        place-items:center;
        overflow:hidden;
        pointer-events:none;
      }
      .bhd-premium-launch-live__curtain {
        position:absolute;
        top:0;
        bottom:0;
        width:50.25%;
        will-change:transform;
      }
      .bhd-premium-launch-live__curtain--left {
        left:0;
        background:#006039;
        animation:bhd-launch-open-left .82s cubic-bezier(.77,0,.18,1) .28s both;
      }
      .bhd-premium-launch-live__curtain--right {
        right:0;
        background:#111111;
        animation:bhd-launch-open-right .82s cubic-bezier(.77,0,.18,1) .28s both;
      }
      .bhd-premium-launch-live__badge {
        position:relative;
        z-index:2;
        display:flex;
        min-width:min(78%,260px);
        flex-direction:column;
        align-items:center;
        justify-content:center;
        padding:11px 18px 10px;
        border-bottom:4px solid #A37E2C;
        background:#111111;
        color:#ffffff;
        box-shadow:0 10px 24px rgba(0,0,0,.18);
        opacity:0;
        transform:translateY(8px) scale(.9);
        animation:bhd-launch-badge-in .42s ease .9s forwards;
        text-align:center;
        text-transform:uppercase;
      }
      .bhd-premium-launch-live__kicker {
        margin:0 0 4px;
        color:#d8c29b;
        font-size:9px;
        font-weight:800;
        line-height:1;
        letter-spacing:.14em;
      }
      .bhd-premium-launch-live__title {
        color:#ffffff;
        font-family:var(--font-heading-family,inherit);
        font-size:clamp(16px,1.7vw,23px);
        font-weight:900;
        line-height:1;
        letter-spacing:.08em;
      }
      .bhd-launch-confetti-v2 {
        position:fixed;
        inset:0;
        z-index:2147483500;
        overflow:hidden;
        pointer-events:none;
      }
      .bhd-launch-confetti-v2__piece {
        position:absolute;
        top:-30px;
        display:block;
        opacity:.98;
        animation:bhd-launch-confetti-v2-fall var(--duration) cubic-bezier(.12,.72,.28,1) var(--delay) forwards;
        will-change:transform;
      }
      @keyframes bhd-launch-open-left { to { transform:translateX(-103%); } }
      @keyframes bhd-launch-open-right { to { transform:translateX(103%); } }
      @keyframes bhd-launch-badge-in { to { opacity:1; transform:translateY(0) scale(1); } }
      @keyframes bhd-launch-confetti-v2-fall {
        0% { transform:translate3d(0,-8vh,0) rotate(0deg); opacity:1; }
        100% { transform:translate3d(var(--drift),112vh,0) rotate(var(--spin)); opacity:.82; }
      }
      @media (max-width:749px) {
        .bhd-premium-launch-live__badge { min-width:min(80%,220px); padding:9px 14px 8px; }
        .bhd-premium-launch-live__title { font-size:16px; }
      }
      @media (prefers-reduced-motion:reduce) {
        .bhd-premium-launch-live__curtain { display:none!important; }
        .bhd-premium-launch-live__badge { opacity:1!important; transform:none!important; animation:none!important; }
        .bhd-launch-confetti-v2 { display:none!important; }
      }
    `;
    document.head.appendChild(style);
  };

  const fireConfetti = (releaseMs) => {
    if (REDUCED_MOTION?.matches) return;
    if (document.querySelector('.bhd-launch-confetti-layer, .bhd-launch-confetti-v2')) return;

    const releaseMinute = Math.floor(releaseMs / 60000);
    const key = `bhdLaunchCelebratedV2:${releaseMinute}`;
    try {
      if (window.sessionStorage.getItem(key) === '1') return;
      window.sessionStorage.setItem(key, '1');
    } catch (error) {}

    const layer = document.createElement('div');
    layer.className = 'bhd-launch-confetti-v2';
    layer.setAttribute('aria-hidden', 'true');
    const colors = ['#006039', '#A37E2C', '#ffffff', '#111111'];

    for (let index = 0; index < 76; index += 1) {
      const piece = document.createElement('span');
      const size = 5 + Math.random() * 8;
      piece.className = 'bhd-launch-confetti-v2__piece';
      piece.style.left = `${Math.random() * 100}%`;
      piece.style.width = `${size}px`;
      piece.style.height = `${size * (0.7 + Math.random() * 1.4)}px`;
      piece.style.background = colors[index % colors.length];
      piece.style.borderRadius = index % 7 === 0 ? '50%' : '0';
      piece.style.setProperty('--delay', `${Math.random() * .7}s`);
      piece.style.setProperty('--duration', `${3.6 + Math.random() * 2}s`);
      piece.style.setProperty('--drift', `${-130 + Math.random() * 260}px`);
      piece.style.setProperty('--spin', `${360 + Math.random() * 900}deg`);
      layer.appendChild(piece);
    }

    document.body.appendChild(layer);
    window.setTimeout(() => layer.remove(), 6500);
  };

  const updateProductGate = (gate, now) => {
    const releaseMs = Number(gate.dataset.releaseMs || 0);
    if (!releaseMs || now < releaseMs) return;

    const sectionId = gate.dataset.sectionId || '';
    const root = document.getElementById(`ProductInfo-${sectionId}`) || gate.closest('.product__info-container');
    const scope = root || document;
    const prelaunch = gate.querySelector('[data-bhd-launch-prelaunch]');
    const outNow = gate.querySelector('[data-bhd-launch-out-now]');
    const purchase = scope.querySelector(`[data-bhd-launch-purchase="${sectionId}"]`);
    const pickup = scope.querySelector(`[data-bhd-launch-pickup="${sectionId}"]`);
    const inLaunchWindow = now < releaseMs + LIVE_WINDOW_MS;

    if (prelaunch) prelaunch.hidden = true;
    if (purchase) purchase.hidden = false;
    if (pickup) pickup.hidden = false;

    normalizeAddToCart(scope);

    if (root) {
      root.classList.add('bhd-launch-product');
      root.classList.remove('bhd-launch-product--prelaunch');
      root.classList.toggle('bhd-launch-product--out-now', inLaunchWindow);
      root.classList.toggle('bhd-launch-product--normal', !inLaunchWindow);
    }

    gate.dataset.state = inLaunchWindow ? 'out-now' : 'normal';
    if (outNow) {
      outNow.hidden = !inLaunchWindow;
      const strong = outNow.querySelector('strong');
      if (strong && inLaunchWindow) strong.textContent = availableNowLabel();
    }

    if (inLaunchWindow) {
      window.setTimeout(() => fireConfetti(releaseMs), 180);
    }
  };

  const expireStandardCardCountdowns = (now) => {
    document.querySelectorAll('countdown-timer[data-date]').forEach((timer) => {
      const releaseMs = parseDate(timer.dataset.date);
      if (!releaseMs || now < releaseMs) return;

      const intervalId = Number(timer.dataset.interval || 0);
      if (intervalId) window.clearInterval(intervalId);
      timer.classList.add('hidden');

      const card = timer.closest('.card-wrapper');
      if (card) normalizeAddToCart(card);
    });
  };

  const removePremiumComingSoon = (card) => {
    card.querySelectorAll('[class*="ai-premium-carousel__coming-soon-overlay-"]').forEach((overlay) => {
      overlay.hidden = true;
      overlay.style.display = 'none';
    });
    card.classList.forEach((className) => {
      if (className.includes('ai-premium-carousel__card--coming-soon-')) card.classList.remove(className);
    });
    card.querySelectorAll('[data-countdown-shell]').forEach((shell) => {
      shell.hidden = true;
      shell.style.display = 'none';
    });
  };

  const premiumCardIsSoldOut = (card) => Array.from(card.classList).some((className) =>
    className.includes('ai-premium-carousel__card--sold-out-') ||
    className.includes('ai-premium-carousel__card--pre-release-sold-out-')
  );

  const addPremiumLaunchReveal = (card, releaseMs) => {
    if (card.querySelector('.bhd-premium-launch-live')) return;
    const imageLink = card.querySelector('[class*="ai-premium-carousel__image-link-"]');
    if (!imageLink) return;

    const overlay = document.createElement('span');
    overlay.className = 'bhd-premium-launch-live';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = `
      <span class="bhd-premium-launch-live__curtain bhd-premium-launch-live__curtain--left"></span>
      <span class="bhd-premium-launch-live__curtain bhd-premium-launch-live__curtain--right"></span>
      <span class="bhd-premium-launch-live__badge">
        <span class="bhd-premium-launch-live__kicker">BARRIO HAT DROP</span>
        <strong class="bhd-premium-launch-live__title">${availableNowLabel()}</strong>
      </span>
    `;
    imageLink.appendChild(overlay);
    card.dataset.bhdLaunchLive = String(releaseMs);
    window.setTimeout(() => fireConfetti(releaseMs), 980);
  };

  const removePremiumLaunchReveal = (card) => {
    card.querySelectorAll('.bhd-premium-launch-live').forEach((overlay) => overlay.remove());
    delete card.dataset.bhdLaunchLive;
  };

  const updatePremiumCarousels = (now) => {
    document.querySelectorAll('[data-product-countdown][data-countdown-date]').forEach((countdown) => {
      const releaseMs = parseDate(countdown.dataset.countdownDate);
      const card = countdown.closest('[data-product-card]');
      if (!releaseMs || !card || now < releaseMs) return;

      removePremiumComingSoon(card);
      normalizeAddToCart(card);

      if (now < releaseMs + LIVE_WINDOW_MS && !premiumCardIsSoldOut(card)) {
        addPremiumLaunchReveal(card, releaseMs);
      } else {
        removePremiumLaunchReveal(card);
      }
    });
  };

  const update = () => {
    const now = Date.now();
    document.querySelectorAll('[data-bhd-launch-gate]').forEach((gate) => updateProductGate(gate, now));
    expireStandardCardCountdowns(now);
    updatePremiumCarousels(now);
  };

  let scheduled = false;
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  injectStyles();
  update();
  document.addEventListener('DOMContentLoaded', update, { once: true });
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('productInfo:loaded', scheduleUpdate);

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(update, TICK_MS);
})();
